import { useEffect } from 'react';
import { useRecoilCallback } from 'recoil';
import { activeSearchState, searchSuggestionsState } from '../states';

const useCleanup = () => {
  const resetAll = useRecoilCallback(({ reset }) => () => {
    reset(searchSuggestionsState);
    reset(activeSearchState);
  });

  useEffect(() => {
    resetAll();
  }, [resetAll]);
};

export default useCleanup;
